<template>
  <div class="subpage-dashboards subpage-notifications--dashboard">
    <h1 class="my-account__title gds-space-stack-l">Notifications</h1>
    <div v-if="loadState === undefined" class="table-loading" />
    <div v-if="loadState === 'down'" class="usage-page--interior-status-container">
      <div class="global-flow-error--outer-container gds-flex-container">
        <div class="global-flow-error--inner-container">
          <img class="maintenance-graphic" src="/wp-content/themes/gmptwentynineteen/assets/images/outages-notifications.svg" />
          <div
            class="maintenance-message maintenance-message--main gds-space-stack-m"
          >We’re upgrading our notifications system and a new interface is coming soon. In the meantime please text "REG" to GMPVT (46788) to register a new contact.</div>
        </div>
      </div>
    </div>
    <div class="usage-page--interior-status-container">
      <flow-error v-if="loadState === 'error'" name="Notification configuration" state="error" />
      <flow-error v-if="loadState === 'maintenance'" name="Notification configuration" state="maintenance" />
    </div>
    <div v-if="loadState === 'complete'">
      <div>
        <div v-if="!editingContact">
          <div
            v-for="contact of unconfirmed"
            :key="contact.contactId"
            class="form-message-box form-message-box--blue form-message-box--full-width gds-space-stack-l gds-flex-container gds-flex-container--space-between"
          >
            <div class="form-message-box--left">The following contact has not been verified: {{contact.value}}</div>
            <div v-if="!contact.resent" class="form-message-box--right">
              <button @click="ReconfirmContact(contact)" type="button" class="gds-button gds-text-button">
                <span class="form-message-box--blue__text-button-text gds-button__text gds-font-size-m">Resend Message</span>
              </button>
            </div>
            <div v-if="contact.resent" class="form-message-box--right">Message sent</div>
          </div>
          <section class="my-account__full-width-section">
            <div class="my-account__notifications-intro-button-wrap gds-flex-container">
              <div>
                <h2 class="no-margin gds-display-1">Contacts</h2>
                <p class="notifications__intro">Where you'd like us to send notifications.</p>
              </div>
              <button @click="EditContact()" type="button" class="gds-button gds-round gds-space-stack-ml">Add New Contact</button>
            </div>

            <div v-if="contacts && contacts.length === 0">This account doesn't have any contacts yet.</div>
            <div v-for="contact of contacts" :key="contact.contactId" class="notifications__row-item gds-flex-container gds-flex-container--top">
              <div class="notifications__row-item-icon">
                <svg class="gds-icon">
                  <use v-if="contact.channel.code==='EMAIL'" xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-email" />
                  <use v-if="contact.channel.code==='SMS'" xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-cell-phone" />
                </svg>
              </div>
              <div class="notifications__row-item--inner-wrap gds-flex-container gds-flex-container--top">
                <div class="notifications__row-item-account">
                  <div v-if="contact.nickname" class="notifications__row-item-account--details">{{contact.nickname}}</div>
                  <div class="gds-flex-container gds-flex-container--left gds-flex-container--wrap">
                    <div class="notifications__row-item-account--details gds-font-demi gds-space-inline-m">{{contact.value}}</div>
                    <div v-if="contact.confirmed !== true" class="notifications__row-item-account--unverified">Unverified</div>
                  </div>
                  <button @click="EditContact(contact)" type="button" class="gds-button gds-text-button">
                    <span class="my-account__notifications--text-button gds-button__text">Edit / Remove</span>
                  </button>
                </div>
                <div class="notifications__row-item-notify-types">
                  <div role="group" class="notifications__row-item-notify-type--fieldset gds-flex-container gds-flex-container--left gds-fieldset">
                    <label v-for="alerttype of alerttypes" :key="alerttype.alertTypeId" class="notifications__checkbox-label gds-checkbox">
                      <div class="notifications__row-item-notify-type--item-label gds-checkbox__label">{{alerttype.name}}</div>
                      <input
                        type="checkbox"
                        :checked="HasSubscription(contact, alerttype)"
                        :disabled="!ValidToSubscribe(contact, alerttype)"
                        @change="Subscribe(contact, alerttype, $event)"
                      />
                      <span class="notifications__checkbox__faux gds-checkbox__faux"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section v-if="alerttypes" class="my-account__full-width-section gds-space-top-xl">
            <h3 class="gds-display-1">Notification Descriptions</h3>
            <div v-for="alerttype of alerttypes" :key="alerttype.alertTypeId" class="notification-descriptions gds-space-stack-l gds-flex-container">
              <img class="notification-descriptions__icon" :src="alerttype.iconUrl" alt="alert icon" />
              <div class="notification-descriptions__texts">
                <div class="gds-display-0 gds-space-stack-m">{{alerttype.name}}</div>
                <div class="gds-font-size-m gds-space-stack-m">{{alerttype.description}}</div>
              </div>
            </div>
          </section>
        </div>
        <div v-if="editingContact">
          <section class="my-account__full-width-section gds-space-stack-xl">
            <div class="gds-flex-container gds-flex-container--space-between gds-space-stack-l">
              <h2 v-if="editingContact.isNew" class="no-margin gds-display-1">New Contact</h2>
              <h2 v-if="!editingContact.isNew" class="no-margin gds-display-1">Edit Contact</h2>
            </div>
            <form class="my-account__edit-contact-form">
              <fieldset class="gds-fieldset gds-space-stack-m">
                <label class="gds-input-field">
                  <span class="gds-input-field__label">Contact Method</span>
                  <div class="gds-position--relative">
                    <span class="gds-input-field__prefix">
                      <svg class="gds-icon my-account__edit-contact-form--icon">
                        <use v-if="editingContact.channelCode==='EMAIL'" xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-email" />
                        <use v-if="editingContact.channelCode==='SMS'" xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-cell-phone" />
                      </svg>
                    </span>
                    <!-- Note: this is not populated dynamically. This is because we have to make assumptions for icon, input name, input format etc.
                    Changing the available alert channels will require code changes.-->
                    <select v-model="editingContact.channelCode" :disabled="!editingContact.isNew" class="bill-pay-input-field__select">
                      <option value="EMAIL">Email</option>
                      <option value="SMS">Text Message (SMS)</option>
                    </select>
                  </div>
                </label>
              </fieldset>
              <fieldset v-if="editingContact.channelCode === 'SMS'" class="gds-fieldset gds-space-stack-m">
                <label class="gds-input-field">
                  <span class="gds-input-field__label">Phone Number</span>
                  <the-mask
                    v-model="editingContact.sms"
                    :mask="'+1 (###) ###-####'"
                    v-validate="'required|min:10'"
                    name="phone number"
                    key="phone number"
                    class="gds-input-field__input"
                    type="tel"
                    placeholder="Your phone number"
                  />
                </label>
                <div v-if="errors.first('phone number')" class="validation-error">{{ errors.first("phone number")}}</div>
              </fieldset>
              <fieldset v-if="editingContact.channelCode === 'EMAIL'" class="gds-fieldset gds-space-stack-m">
                <label class="gds-input-field">
                  <span class="gds-input-field__label">Email Address</span>
                  <input
                    v-model="editingContact.email"
                    v-validate="'required|email'"
                    name="email address"
                    key="email address"
                    class="gds-input-field__input"
                    type="email"
                    autocomplete="email"
                    placeholder="Your email"
                  />
                </label>
                <div v-if="errors.first('email address')" class="validation-error">{{ errors.first("email address")}}</div>
              </fieldset>
              <fieldset class="gds-fieldset gds-space-stack-m">
                <label class="gds-input-field">
                  <span class="gds-input-field__label">Nickname</span>
                  <input
                    v-model="editingContact.nickname"
                    v-mask="{mask: 'CCCCCCCCCCCC', tokens: alphanumspacemask }"
                    class="gds-input-field__input"
                    type="text"
                    placeholder="Type here..."
                  />
                </label>
              </fieldset>
            </form>
          </section>

          <section class="my-account__full-width-section">
            <div class="gds-space-stack-ml">
              <h2 class="no-margin gds-display-1">Do Not Disturb</h2>
            </div>
            <p class="notification__terms gds-space-stack-l">When enabled, we will not send notifications to this contact during the specified times.</p>
            <form class="my-account__dndisturb-form">
              <fieldset class="gds-fieldset">
                <label class="gds-checkbox">
                  <input v-model="editingContact.dndEnable" type="checkbox" />
                  <span class="gds-checkbox__faux"></span>
                  <span class="gds-checkbox__label gds-font-demi">Don't send me notifications from:</span>
                </label>
              </fieldset>
              <fieldset class="gds-fieldset gds-space-stack-l">
                <div class="my-account-dndisturb gds-flex-container gds-flex-container--space-between">
                  <select v-model="editingContact.dndStart" class="bill-pay-input-field__select">
                    <option value="00:00:00">12:00 AM</option>
                    <option value="01:00:00">1:00 AM</option>
                    <option value="02:00:00">2:00 AM</option>
                    <option value="03:00:00">3:00 AM</option>
                    <option value="04:00:00">4:00 AM</option>
                    <option value="05:00:00">5:00 AM</option>
                    <option value="06:00:00">6:00 AM</option>
                    <option value="07:00:00">7:00 AM</option>
                    <option value="08:00:00">8:00 AM</option>
                    <option value="09:00:00">9:00 AM</option>
                    <option value="10:00:00">10:00 AM</option>
                    <option value="11:00:00">11:00 AM</option>
                    <option value="12:00:00">12:00 PM</option>
                    <option value="13:00:00">1:00 PM</option>
                    <option value="14:00:00">2:00 PM</option>
                    <option value="15:00:00">3:00 PM</option>
                    <option value="16:00:00">4:00 PM</option>
                    <option value="17:00:00">5:00 PM</option>
                    <option value="18:00:00">6:00 PM</option>
                    <option value="19:00:00">7:00 PM</option>
                    <option value="20:00:00">8:00 PM</option>
                    <option value="21:00:00">9:00 PM</option>
                    <option value="22:00:00">10:00 PM</option>
                    <option value="23:00:00">11:00 PM</option>
                  </select>

                  <div class="my-account__text-between-selects">to</div>

                  <select v-model="editingContact.dndEnd" id="my-account-dndisturb-end" class="bill-pay-input-field__select">
                    <option value="00:00:00">12:00 AM</option>
                    <option value="01:00:00">1:00 AM</option>
                    <option value="02:00:00">2:00 AM</option>
                    <option value="03:00:00">3:00 AM</option>
                    <option value="04:00:00">4:00 AM</option>
                    <option value="05:00:00">5:00 AM</option>
                    <option value="06:00:00">6:00 AM</option>
                    <option value="07:00:00">7:00 AM</option>
                    <option value="08:00:00">8:00 AM</option>
                    <option value="09:00:00">9:00 AM</option>
                    <option value="10:00:00">10:00 AM</option>
                    <option value="11:00:00">11:00 AM</option>
                    <option value="12:00:00">12:00 PM</option>
                    <option value="13:00:00">1:00 PM</option>
                    <option value="14:00:00">2:00 PM</option>
                    <option value="15:00:00">3:00 PM</option>
                    <option value="16:00:00">4:00 PM</option>
                    <option value="17:00:00">5:00 PM</option>
                    <option value="18:00:00">6:00 PM</option>
                    <option value="19:00:00">7:00 PM</option>
                    <option value="20:00:00">8:00 PM</option>
                    <option value="21:00:00">9:00 PM</option>
                    <option value="22:00:00">10:00 PM</option>
                    <option value="23:00:00">11:00 PM</option>
                  </select>
                </div>
              </fieldset>

              <div v-if="editingContact.channelCode==='SMS'" class="notification__terms gds-space-stack-l">
                <p>
                  By turning on SMS notifications, you agree to receive power outage or other account-related text messages from
                  <strong>Green Mountain Power</strong>. This service will also allow you to report power outages to GMP and check outage status. For more information, text
                  <strong>HELP</strong> to
                  <strong>46788 (GMPVT)</strong>. To stop notifications, text
                  <strong>STOP</strong> to
                  <strong>46788 (GMPVT)</strong>. Message and data rates may apply. Message frequency varies. See our
                  <a href="/notification-terms-conditions/">Terms of Use</a> and
                  <a href="/legal/">Privacy Policy</a>.
                </p>

                <fieldset class="gds-fieldset notifications__long-fieldset">
                  <label class="gds-checkbox">
                    <input v-validate="'required'" name="termsofuse" type="checkbox" />
                    <span class="gds-checkbox__faux"></span>
                    <span class="notifications__checkbox-label-with-link gds-checkbox__label gds-font-demi">
                      I have read and agree to the
                      <a href="/notification-terms-conditions/">Terms of Use</a>
                    </span>
                  </label>
                  <div v-if="errors.first('termsofuse')" class="validation-error">{{ errors.first("termsofuse")}}</div>
                </fieldset>
              </div>

              <div class="gds-flex-container gds-flex-container--left gds-space-stack-l">
                <button @click="editingContact = undefined" type="button" class="gds-button gds-secondary gds-space-inline-m">Cancel</button>
                <button @click="SaveContact()" type="button" class="gds-button gds-space-inline-m">Save</button>
              </div>

              <div v-if="!editingContact.isNew">
                <button @click="DeleteContact()" type="button" class="my-account__dndisturb-submit gds-button gds-text-button">Remove Contact</button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GMPAPI from '../../../services/gmpapi';
import { DumpError } from '../../../utilities';
import { GetComponentStatus } from '../../../services/statuspage';

export default {
  name: "SubpageNotifications",
  data() {
    return {
      editingContact: undefined,
      contacts: [],
      unconfirmed: [],

      alerttypes: [],
      alertchannels: [],

      alphanumspacemask: {
        "C": {
          pattern: /[0-9a-zA-Z ]/,
        },
      },

      // TODO: start back at undefined to turn notifications back on
      loadState: !!this.$store.state.user.userinfo.isAdmin ? undefined : 'down',
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
    isAdmin() {
      return !!this.$store.state.user.userinfo.isAdmin;
    },
  },
  async mounted() {
    await this.PopulateAlertValues();
  },
  methods: {
    async PopulateAlertValues() {
      if (this.loadState === "down") return;
      this.contacts = undefined;
      this.alerttypes = undefined;
      this.alertchannels = undefined;
      this.unconfirmed = undefined;
      this.loadState = undefined;
      if (!this.currentAccount) {
        this.loadState = "error";
        return;
      }
      // Before we do anything else, check for outages
      const status = await GetComponentStatus("Notification");
      if (status !== "operational") {
        this.loadState = status;
        return;
      }
      try {
        const [contacts, alerttypes, alertchannels] = await Promise.all([
          GMPAPI.GetAlertContacts(this.currentAccount.accountNumber),
          GMPAPI.GetAlertTypes(this.currentAccount.accountNumber),
          GMPAPI.GetAlertChannels(),
        ]);
        for (const contact of contacts) {
          contact.resent = false;
        }
        this.contacts = contacts;
        this.alerttypes = alerttypes;
        this.alertchannels = alertchannels;
        this.unconfirmed = contacts.filter(item => item.confirmed !== true);
        this.loadState = "complete";
      } catch (err) {
        DumpError("Notifications refresh error", err);
        this.loadState = "error";
      }
    },
    HasSubscription(contact, alerttype) {
      if (contact.subscriptions) {
        const found = contact.subscriptions.find(item => item.alertType.alertTypeId === alerttype.alertTypeId);
        if (found) return true;
      }
      return false;
    },
    ValidToSubscribe(contact, alerttype) {
      if (alerttype.channels) {
        const found = alerttype.channels.find(item => item.channelId === contact.channel.channelId);
        if (found) return true;
      }
      return false;
    },
    async Subscribe(contact, alerttype, event) {
      if (event.target.checked) {
        await GMPAPI.SubscribeAlert(this.currentAccount.accountNumber, contact.contactId, alerttype.alertTypeId);
      } else {
        const subscription = contact.subscriptions.find(item => item.alertType.alertTypeId === alerttype.alertTypeId);
        if (subscription) {
          await GMPAPI.UnSubscribeAlert(this.currentAccount.accountNumber, subscription.subscriptionId);
        } else {
          console.error("No subscription for " + contact.value + " " + alerttype.name);
        }
      }
      // Get subscriptions again but don't bother refreshing the whole page
      this.contacts = await GMPAPI.GetAlertContacts(this.currentAccount.accountNumber);
    },
    async ReconfirmContact(contact) {
      await GMPAPI.ResendContactVerification(this.currentAccount.accountNumber, contact.contactId);
      contact.resent = true;
    },
    EditContact(contact) {
      if (!contact) {
        this.editingContact = {
          isNew: true,
          channelCode: "EMAIL",
          dndEnable: false,
          dndStart: "22:00:00",
          dndEnd: "07:00:00",
        };
      } else {
        this.editingContact = {
          contactId: contact.contactId,
          channelCode: contact.channel.code,
          dndEnable: contact.dndStart || contact.dndEnd,
          dndStart: contact.dndStart || "22:00:00",
          dndEnd: contact.dndEnd || "07:00:00",
          email: contact.channel.code === "EMAIL" ? contact.value : undefined,
          sms: contact.channel.code === "SMS" ? contact.value : undefined,
          nickname: contact.nickname,
        };
      }
      window.scrollTo(0, 0);
    },
    async DeleteContact() {
      await GMPAPI.DeleteContact(this.currentAccount.accountNumber, this.editingContact.contactId);
      // Refresh contacts
      await this.PopulateAlertValues();
      // Hide editor
      this.editingContact = undefined;
    },
    async SaveContact() {
      if (await this.$validator.validateAll()) {
        const desiredChannel = this.alertchannels.find(item => item.code === this.editingContact.channelCode);
        const value = this.editingContact.channelCode === "EMAIL" ? this.editingContact.email : this.editingContact.sms;
        const contactDetails = {
          channel: {
            channelId: desiredChannel.channelId,
          },
          nickname: this.editingContact.nickname,
          value: value,
          dndStart: this.editingContact.dndEnable ? this.editingContact.dndStart : null,
          dndEnd: this.editingContact.dndEnable ? this.editingContact.dndEnd : null,
        }
        try {
          if (this.editingContact.isNew) {
            await GMPAPI.CreateContact(this.currentAccount.accountNumber, contactDetails);
          } else {
            await GMPAPI.UpdateContact(this.currentAccount.accountNumber, this.editingContact.contactId, contactDetails);
          }
          // Refresh contacts
          await this.PopulateAlertValues();
          // Hide editor
          this.editingContact = undefined;
        } catch (err) {
          DumpError("Save contact error", err);
          if (err.response && err.response.data) {
            const code = err.response.data.code;
            // Take specific actions on certain error codes here
            if (this.editingContact.channelCode === "SMS" && err.response.data.code === 4 && err.response.data.field === "value") {
              // Make sure we have a fresh ErrorBag for handling special cases
              if (!this.errors) this.errors = new ErrorBag();
              this.errors.add({ field: "phone number", msg: "Invalid phone number" });
            }
          }
        }
      }
    }
  },
  watch: {
    // Refresh data whenever the account changes
    async currentAccount() {
      await this.PopulateAlertValues();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>